import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  beautify,
  createColumn,
  createViewAction,
  formatDateTime,
} from "../../utils/helpers";
import { URL_REVERSAL_HOLDINGS } from "../../utils/urls";

export const useReversalHoldings = () => {
  const tableColumns = () => [
    createColumn("account_code", true, "Account Code"),
    createColumn("reason", true, "Reason"),
    createColumn("processed", true, "Is Processed"),
    createColumn("created_by", true, "Created By"),
    createColumn("created_at", false),
    createColumn("actions", false),
  ];

  const tableData = (data) => {
    if (!data) return [];

    return data.map((item) => ({
      ...item,
      processed: <BooleanTags status={item?.processed} />,
      created_at: formatDateTime(item?.created_at),
      created_by: beautify(item?.created_by),
      actions: (
        <FormActions
          actions={[createViewAction(URL_REVERSAL_HOLDINGS, item?.id)]}
        />
      ),
    }));
  };

  const viewData = (item) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: { message: "No data available" },
          },
        ],
      };
    }

    return {
      sections: [
        {
          title: "Reversal Holding Details",
          fields: {
            id: item?.id,
            transaction_id: item?.transaction_id,
            account_code: item?.account_code,
            reason: item?.reason,
            processed: <BooleanTags status={item?.processed} />,
            created_at: formatDateTime(item.created_at),
            created_by: beautify(item.created_by),
          },
        },
      ],
    };
  };

  return {
    tableData,
    tableColumns,
    viewData,
  };
};
